export type LabViewMode = 'user' | 'developer';

export const LAB_VIEW_MODE_STORAGE_KEY = 'matrix-fill-lab:view-mode';

export function parseViewMode(raw: string | null | undefined): LabViewMode {
  return raw === 'user' ? 'user' : 'developer';
}
